<template>
  <Content @back="back" :noBack="['expert','organ'].includes(userRole)">
    <template v-slot:nav_left>
      球队管理
    </template>
    <template v-slot:nav_right>
      <div class="yioks_btn" @click="addSquad=true;isEdit=false;squadUuid=''" v-if="isCanEditData">
        <!-- <v-icon name="plus" scale="1"  style="margin-right: .1rem"></v-icon> -->
        添加球队
      </div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
          <select v-model="selectVal.organUuid" class="yioks_select" @change="changeSelectOrg" >
            <option v-if="selectOrganList.length > 1" value=''>全部区体育行政部门</option>
            <option
              v-for="item in selectOrganList"
              :key="item.organUuid"
              :value="item.organUuid"
            >{{ item.organShortName }}</option>
          </select>
          <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeQuery(true)" >
            <option v-if="selectCenterList.length !== 1" value=''>全部培训机构</option>
            <option
              v-for="item in selectCenterList"
              :key="item.uuid"
              :value="item.uuid"
            >{{ item.youthShortName }}</option>
          </select>

          <select
              v-model="selectVal.squadDissolve"
              class="yioks_select" style="width: 100px;"
              @change="changeQuery(true)"
          >
            <option value="">球队状态</option>
            <option value="0">正常</option>
            <option value="1">已停止</option>
          </select>
<!--          <select-->
<!--            v-model="selectVal.playerNum"-->
<!--            class="yioks_select" style="width: 140px;"-->
<!--            @change="changeQuery(true)"-->
<!--          >-->
<!--            <option value="">球员团队数量</option>-->
<!--            <option value="10">大于等于10人</option>-->
<!--            <option value="20">大于等于20人</option>-->
<!--          </select>-->
        </div>
        <div class="search_box">
          <input
            v-model.trim="selectVal.keyWord"
            type="text"
            class="yioks_input"
            style="width: 130px;"
            placeholder="请输入关键词"
            @keyup.enter="changeQuery(true)"
          >
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th squadName"><strong>球队简称</strong></div>
              <!--<div class="th organName"><strong>管理单位</strong></div>-->
              <div class="th centerName"><strong>单位</strong></div>
              <div class="th coachName"><strong>主教练</strong></div>
              <div class="th leaderName"><strong>教练员团队</strong></div>
<!--              <div class="th leaderName"><strong>球员团队</strong></div>-->
              <div class="th leaderName13"><strong>本年注册球员</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll >
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                    v-for="(item, index) in squadList"
                    :key="index"
                    class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td squadName">
                      <p :class="{ squadDissolve: item.squadDissolve }">{{ item.shortName || '--' }}</p>
                    </div>
                    <!--<div class="td organName">-->
                      <!--<p>{{ item.organShortName || '&#45;&#45;' }}</p>-->
                    <!--</div>-->
                    <div class="td centerName" :title="item.youthShortName">
                      <p>{{ item.youthShortName || '--' }}</p>
                    </div>
                    <div class="td coachName" style="display: block;text-align: center;line-height: 24px;">
                      <p>{{item.chiefCoachName || '--'}}</p>
                      <p v-if="item.chiefCoachName">{{ item.chiefCoachLevel | coachClassLevel}}</p>
                    </div>
                    <div class="td leaderName">
                      <p>{{item.coachTeamNum}} 人</p>
                    </div>
<!--                    <div class="td leaderName">-->
<!--                      <p>{{item.playerTeamNum  || 0}} 人</p>-->
<!--                    </div>-->
                    <div class="td leaderName13">
                      <p>{{item.signUpPlayerTeamNum || 0}} 人</p>
                    </div>
                    <div class="td opt">
                      <p>
                        <span class="item" @click="goDetail(item.uuid)">查看</span>
                        <span class="split" v-if="isCanEditData">/</span>
                        <span class="item" @click="editSquad(item.uuid)" v-if="isCanEditData">编辑</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty v-if="empty"
          tips="暂时没有数据 ~ "
          :name="isCanEditData ? '立即添加球队' : ''"
          @callback="addType='squad';addSquad = true;isEdit=false;squadUuid=''"></yioks-empty>
      </div>
      <Pagination :total="total" :page.sync="page" />
      <yioks-tip :showTip="showTip" :tipMsg="$t('deleteTeamTips')" @callback='isDelete' />
      <template v-if="addSquad">
        <AddSquadDialog
          :addSquad.sync="addSquad"
          :isEdit="isEdit"
          :squadUuid="squadUuid"
          :organList="organList"
          @hideAddsquadDialog="hideAddsquadDialog" ></AddSquadDialog>
      </template>
    </template>
  </Content>
</template>

<script>

import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/regular/trash-alt'
import 'vue-awesome/icons/regular/edit'
import squad from '@/api/squad'
import coach from '@/api/coach'
import common from '@/api/common'
import scoreImg from '@/assets/images/common/squad.png'
import storage from '@/utils/storage'
import squadFormRule from '@/utils/formRules/squad'
import { ops } from '@/utils/scrollIndialog'
import squadDuty from '@/api/squadDuty'
import mixinAppConfig from "@/mixin/mixinAppConfig";
import { coachClassLevel } from "@/utils/yioks_filter";
export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'AddSquadDialog': () => import('@/components/squad')
  },
  filters: {
    coachClassLevel,
    filterSex (val) {
      switch (val) {
        case 'male': return '男足'
        case 'female': return '女足'
        case 'mixed': return '男女混合'
        default: return '--'
      }
    }
  },
  mixins: [squadFormRule,mixinAppConfig],
  data () {
    return {
      ops,
      nameList: [],
      leaderList: [],
      positionList: [],
      squadList: [],
      addSquad: false,
      addbtnLoading: false,
      isEdit: false,
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      squadUuid: '',
      total: 0,
      pageSize: 20,
      page: 0,
      empty: false,
      showList: false,
      scoreImg,
      showTip: false,
      squadNameList: [],
      loading: true,
      squadName: '',
      centerList: [],
      organList: [],
      selectCenterList: [],
      selectOrganList: [],
      selectVal: {
        organUuid: '',
        youthUuid: '',
        keyWord: '',
        playerNum: '',
        squadDissolve: 0
      },
      selectedCoach: '',
      selectedCoachList: [],
      editing: false
    }
  },
  watch: {
    page () {
      this.changeQuery()
    }

  },
  created () {
    const { page, keyWord, organUuid, youthUuid, squadDissolve,playerNum } = this.$route.query
    page && (this.page = Number(page))
    keyWord && (this.$set(this.selectVal, 'keyWord', keyWord))
    organUuid && (this.$set(this.selectVal, 'organUuid', organUuid))
    youthUuid && (this.$set(this.selectVal, 'youthUuid', youthUuid))
    squadDissolve && (this.$set(this.selectVal, 'squadDissolve', squadDissolve))
    playerNum && (this.$set(this.selectVal, 'playerNum', playerNum))
    this.getOrganListAndCenterList()
    this.getSquadList()
    // this.getSquadList()
    // this.getSquadName()
    this.getDutyList()
  },
  methods: {
    back(){
      if ( this.userRole === "expert" || this.userRole === "organ"){
        this.$router.go(-1)
      }else if ( this.userRole === "admin"){
        this.$router.push('/home/index?details=mans')
      }else {
        this.$router.push('/home')
      }
    },
    getDutyList () {
      squadDuty.getAllDuty().then(res => {
        this.positionList = res
      })
    },
    getCoachList (youthUuid) {
      let request
      if (this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert') {
        request = squad.getCoachListSystem
      } else if (this.userRole === 'organ') {
        request = squad.getCoachListOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = squad.getCoachListYouth
      }
      request({ youthUuid }).then(res => {
        this.nameList = res.coachOptionVos
        this.leaderList = res.leaderOptionVos
      })
    },
    getSquadName () {
      common.getAllSquad().then(res => {
        this.squadNameList = res
      })
    },
    getSquadList () {
      this.loading = true
      this.empty = false
      this.showList = false
      let request
      if (this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert') {
        request = squad.getSquadBySystem
      } else if (this.userRole === 'organ') {
        request = squad.getSquadByOrg
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = squad.getSquadByYouth
      }
      request({ page: this.page, size: this.pageSize, key: this.selectVal.keyWord, squadDissolve: this.selectVal.squadDissolve,playerNum: this.selectVal.playerNum, organUuid: this.selectVal.organUuid, youthUuid: this.selectVal.youthUuid }).then((res) => {
        this.loading = false
        this.total = res.totalElements
        if (res.content.length) {
          this.squadList = res.content
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    deleteSquad (uuid) {
      this.showTip = true
      this.delUuid = uuid
    },
    isDelete (isSure) {
      if (isSure) {
        squad.deleteSquad(this.delUuid).then(res => {
          this.showTip = false
          this.getSquadList()
        })
      } else {
        this.showTip = false
      }
    },
    editSquad (uuid) {
      this.squadUuid = uuid
      this.addSquad = true
      this.isEdit = true
    },
    goDetail (uuid) {
      this.$router.push({
        path: 'detail',
        query: {
          uuid
        }
      })
    },
    hideAddsquadDialog (flag) {
      this.isEdit = false
      this.addSquad = flag
      this.getSquadList()
    },
    // getOrganListAndCenterList (geList) {
    getOrganListAndCenterList () {
      let data = this.uuid
      let request
      if (this.userRole === 'organ') {
        request = coach.getCenterListByOrgan
      } else if (this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert') {
        request = coach.getCenterListBySystem
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = coach.getCenterListByYouth
      }
      request(data).then((res) => {
        this.organList = res
        this.selectOrganList = res
        if (this.organList.length === 1) {
          this.$set(this.selectVal, 'organUuid', this.organList[0].organUuid)
          this.selectCenterList = this.selectOrganList.find(item => {
            return item.organUuid === this.selectVal.organUuid
          }).youthList || []
          if (this.selectCenterList.length === 1) {
            this.$set(this.selectVal, 'youthUuid', this.selectCenterList[0].uuid)
          }
        }
        this.selectVal.organUuid && this.setCenterList()
        // geList()
      })
    },
    setCenterList () {
      this.selectCenterList = this.selectOrganList.find(item => {
        return item.organUuid === this.selectVal.organUuid
      }).youthList || []
      this.centerList = this.selectCenterList
    },
    changeQuery (flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          keyWord: this.selectVal.keyWord,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
          squadDissolve: this.selectVal.squadDissolve,
          playerNum: this.selectVal.playerNum,
        }
      })
      this.getSquadList()
    },
    changeSelectOrg () {
      this.$set(this.selectVal, 'youthUuid', '')
      if (this.selectVal.organUuid) {
        this.selectCenterList = this.selectOrganList.find(item => {
          return item.organUuid === this.selectVal.organUuid
        }).youthList || []
        if (this.selectCenterList.length === 1) {
          this.$set(this.selectVal, 'youthUuid', this.selectCenterList[0].uuid)
        }
      } else {
        this.selectCenterList = []
        this.$set(this.selectVal, 'youthUuid', '')
      }
      this.changeQuery(true)
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .yioks_select
    width: 160px;
  .yioks_select120
    width: 120px;
  .list_wrap
    flex 1
    overflow hidden
    .table {
      display flex
      flex-direction column
      flex 1
      width: 100%;
      // margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 425px;
        padding-bottom 15px
        /*flex 1 */
        /*overflow hidden*/
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color_white;
        }
      }
      .seq {
        width 5%
      }
      .squadName{
        width 22%
      }
      /*.organName{
        width 16%
      }*/
      .centerName{
        width 22%
      }
      .coachName{
        width: 14%;
      }
      .leaderName{
        width 14%
      }
      .leaderName13{
        width 13%
      }
      .opt{
        width: 13%;
        p{
          width 100%
          text-align center
          .item{
            cursor: pointer;
            user-select: none;
            color $green_color
          }
          .split{
            margin 0 5px
          }
        }
      }
      .squadDissolve{
        color: #f88594 !important
      }
    }
  .demo-ruleForm
    height 475px
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
</style>

